import { style } from '@vanilla-extract/css'

import { getFontSize } from '~/styles/mixins/font.css'
import { getMarginListItems, getPaddingListItem } from '~/styles/mixins/list.css'
import { getMediaQuery } from '~/styles/mixins/mediaQuery.css'
import { cssVariables } from '~/styles/variables/cssVariables.css'

export const layoutFooter = style({
  marginTop: 'auto',
  backgroundColor: cssVariables.color.outerSpace.hex,
  color: cssVariables.color.edward.hex,
})

export const layoutFooter_wrapper = style({})

export const layoutFooter_contents = style({
  paddingTop: 16,
})

export const layoutFooterContents = style({
  display: 'flex',
})

export const layoutFooterContentsLogo = style({
  flexShrink: 0,
})

export const layoutFooterContentsLogo_image = style({
  width: '164px',
  height: 'auto',
})

export const layoutFooter_copy = style({
  padding: '16px 0',
})

export const layoutFooterCopy = style({
  paddingTop: 16,
  borderTop: `1px solid ${cssVariables.color.corduroy.hex}`,
  display: 'flex',
  flexDirection: 'column-reverse',

  '@media': {
    [getMediaQuery('sm')]: {
      flexDirection: 'row',
      alignItems: 'center',
    },
  },
})

export const layoutFooterCopy_paragraph = style({
  fontSize: getFontSize(12),
  marginTop: 16,

  '@media': {
    [getMediaQuery('sm')]: {
      marginTop: 0,
      marginRight: 24,
      flexShrink: 0,
    },
  },
})

export const layoutFooterCopy_text = style({})

export const layoutFooterContact = style({
  overflow: 'hidden',

  '@media': {
    [getMediaQuery('sm')]: {
      marginLeft: 'auto',
    },
  },
})

export const layoutFooterContact_container = style({
  margin: getMarginListItems(8),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
})

export const layoutFooterContact_text = style({
  padding: getPaddingListItem(8),
  textAlign: 'right',
  fontSize: getFontSize(12),
})

export const layoutFooterContact_button = style({
  padding: getPaddingListItem(8),
})
